/** Profile card: identity, country and currency -- all editable in the dialog. */
import type { ShopSummary } from '../../api/types.ts';
import { DetailRow } from './DetailRow.tsx';
import { EditableCard } from './EditableCard.tsx';
import { SHOP_TYPE_OPTIONS } from './shopsHelpers.ts';

export interface ShopProfileCardProps {
  shop: ShopSummary;
  canWrite: boolean;
  onSaved: () => void;
}

export function ShopProfileCard({ shop, canWrite, onSaved }: Readonly<ShopProfileCardProps>): React.JSX.Element {
  const typeLabel = SHOP_TYPE_OPTIONS.find((o) => o.value === shop.shop_type)?.label ?? shop.shop_type;

  return (
    <EditableCard title="Profile" group="profile" shop={shop} canWrite={canWrite} onSaved={onSaved}>
      <DetailRow label="Name" value={shop.name} />
      <DetailRow label="Type" value={typeLabel} />
      <DetailRow label="Country" value={shop.country_code ?? '-'} />
      <DetailRow label="Currency" value={shop.currency_code ?? '-'} />
    </EditableCard>
  );
}

export default ShopProfileCard;
